import { DataSourceMode, Layout, ValidationResult } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { Contact } from "@mcleod/general/src/Contact";
import { MobileCommControlCredentialsTable } from "./MobileCommControlCredentialsTable";

export class MobileCommControlCredentials extends Contact {
    private layout: MobileCommControlCredentialsTable;

    override async onLoad(): Promise<void> {
        this.addLayoutLoadListener(async () => {
            this.layout = Layout.getLayout("lme/dispatch/mobilecomm/MobileCommControlCredentialsTable") as MobileCommControlCredentialsTable;
            await this.layout.onLoad();
        })
    }

    textboxWebPasswordOnChange(event) {
        if (!StringUtil.isEmptyString(event.oldValue) && event.oldValue !== event.newValue) {
            this.textboxWebPassword.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                return this.layout.getPasswordValidationMessage(this.textboxWebPassword, mode);
            };
        }
    }

    override sourceContactsOnDisplay() {
        super.sourceContactsOnDisplay();
        this.textboxWebPassword.enabled = true;
    }
}
